import ApiClient from './ApiClient';

// Plain ApiClient, not the cache-enabled one: schedules are read by two administrator-only screens and
// change rarely, so the IndexedDB cache would buy nothing and would bring the invalidation trap with it —
// a payload change that only lands after `Account#reset_cache_keys` (STATUS.md, "Pegadinhas de deploy" #3).
class WorkSchedulesAPI extends ApiClient {
  constructor() {
    super('work_schedules', { accountScoped: true });
  }
}

export default new WorkSchedulesAPI();
